import React from 'react';

import { Modal, message } from 'antd';

import fetch from '../../fetch';

/**
 * @method list
 * @param {array} data
 * @return {promise}
 */
const list = (data) => {
	return fetch.post('ky/base/budgetSubject/list', data)
}

const queryByStandardId = (id) => {
	return fetch.post('ky/base/budgetSubject/queryByStandardId/' + id, {})
}


export default {
	list,
	queryByStandardId
}